// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"menu_menuContainer__pHOQ9","expandButton":"menu_expandButton__1UNGO"};